import React from "react";
import SensorBase from "./SensorBase";
import {  TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";
import { TCustomProcessFn } from "../types";
import IrrigationHour from "../../../components/IrrigationHour";
import { generateColorForItem } from "../util";

const FIELD = "soilMoisture2";
const UNIT = "kPa";

const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse 
) => {
  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(
      Number(item.soilMoisture2),
      item.minThresholdValue,
      item.minOptimalValue,
      item.maxOptimalValue,
      item.maxThresholdValue
    ),  
  }));
  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,   
  };
};

const  SoilMoisture2: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT}
        customProcessFn={customProcessFn}></SensorBase>
      <IrrigationHour />
    </div>
  );
};

export default  SoilMoisture2;
